import { render, staticRenderFns } from "./RegisterDisabled.vue?vue&type=template&id=d0c1e164"
import script from "./RegisterDisabled.vue?vue&type=script&lang=js"
export * from "./RegisterDisabled.vue?vue&type=script&lang=js"
import style0 from "./RegisterDisabled.vue?vue&type=style&index=0&id=d0c1e164&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports